<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center" class="pt-8" no-gutters>
        <v-col xl="8" lg="11" md="11" sm="11" cols="12">
          <v-row justify="center" class="mx-0">
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="user.email"
                label="Correo"
                hint="Requerido"
                :rules="[isRequired, isEmail]"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-select class="mt-n4" v-model="user.gender"
                :items="genders"
                item-text="name"
                item-value="key"
                label="Genero"
                hint="Opcional"
                persistent-hint
                solo>
              </v-select>
            </v-col>
           <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="user.first_name"
                label="Nombre"
                hint="Requerido"
                :rules="[isRequired, minimum(3)]"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
           <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="user.last_name"
                label="Apellidos"
                hint="Requerido"
                :rules="[isRequired, minimum(3)]"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-select class="mt-n4" v-model="user.document_type"
                :items="documentTypes"
                item-text="name"
                item-value="key"
                label="Tipo de documento"
                hint="Opcional"
                persistent-hint
                solo>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="user.document_number"
                label="Número de documento"
                hint="Opcional"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-menu ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field class="mt-n4"
                    :value="dateOfBirthFormatted"
                    label="Fecha de nacimiento"
                    hint="Opcional"
                    persistent-hint
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    solo></v-text-field>
                </template>
                <v-date-picker v-model="dateOfBirthFormatted" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="user.phone_number"
                label="Número de teléfono"
                hint="Opcional"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end" class="mt-n3 pb-6 mx-0">
            <v-col xl="6" lg="6" md="6" sm="12" cols="12">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" :disabled="!valid" :dark="valid" @click="save">
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { isRequired, isEmail, minimum } from '@/shared/validations'
import { dateFormat } from '@/shared/format'
import { GENDERS } from '@/shared/gender'
import { DOCUMENT_TYPES } from '@/shared/documentType'

export default {
  name: 'AccountForm',
  props: {
    user: {
      type: Object,
      default: function () {
        return {
          email: null,
          first_name: null,
          last_name: null,
          document_type: null,
          document_number: null,
          phone_number: null,
          date_of_birth: null,
          gender: null
        }
      }
    }
  },
  data () {
    return {
      isRequired,
      isEmail,
      minimum,
      valid: true,
      menu: false,
      genders: GENDERS,
      documentTypes: DOCUMENT_TYPES
    }
  },
  computed: {
    ...mapState('shared', ['loading']),
    dateOfBirthFormatted: {
      get () {
        return this.user.date_of_birth ? dateFormat(this.user.date_of_birth, 'YYYY-MM-DD') : ''
      },
      set (dateOfBirth) {
        this.user.date_of_birth = dateFormat(dateOfBirth)
      }
    }
  },
  methods: {
    ...mapActions('user', ['updateUser']),
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      await this.updateUser(this.user)
      this.$emit('save')
    }
  }
}
</script>
